import { createServerSideRequestOption, getBaseUrl } from "@/redux/config";

const BASE_PATH = "/fees";

export class ServiceFeeGroupService {
  private static async fetchWithServerRequest<T>(options: {
    url: string;
    request: Request;
    method: serverSideHttpMethod;
    body?: unknown;
  }): Promise<T | null> {
    const res = await createServerSideRequestOption({
      url: `${getBaseUrl()}${options.url}`,
      request: options.request,
      method: options.method,
      body: options.body,
    });

    return res.ok ? res.json() : null;
  }

  static getEndpointUrl(params: BaseServiceFeeParams, suffix = "") {
    return `/c/${params.companyId}/services/${params.serviceId}${BASE_PATH}${suffix}`;
  }

  static async getServiceFeeGroup(
    request: Request,
    params: ServiceFeeGroupParams
  ) {
    return this.fetchWithServerRequest<ServiceFeeGroup>({
      url: this.getEndpointUrl(params, `/${params.groupId}`),
      request,
      method: "GET",
    });
  }

  static async deleteServiceFeeGroup(
    request: Request,
    params: ServiceFeeGroupParams
  ) {
    return this.fetchWithServerRequest<void>({
      url: this.getEndpointUrl(params, `/${params.groupId}`),
      request,
      method: "DELETE",
    });
  }

  static async editServiceFeeGroup(
    request: Request,
    params: ServiceFeeGroupParams,
    data: ServiceFeeGroupData
  ) {
    return this.fetchWithServerRequest<ServiceFeeGroup>({
      url: this.getEndpointUrl(params, `/${params.groupId}`),
      request,
      method: "PUT",
      body: data,
    });
  }

  static async createServiceFeeGroup(
    request: Request,
    params: BaseServiceFeeParams,
    data: ServiceFeeGroupData
  ) {
    return this.fetchWithServerRequest<ServiceFeeGroup>({
      url: this.getEndpointUrl(params),
      request,
      method: "POST",
      body: data,
    });
  }

  static async listGroups(
    request: Request,
    params: BaseServiceFeeParams,
    search?: string
  ) {
    return this.fetchWithServerRequest<ServiceFeeGroup[]>({
      url: this.getEndpointUrl(params) + (search ? `?search=${search}` : ""),
      request,
      method: "GET",
    });
  }

  static async deleteScale(request: Request, params: ServiceFeeScaleParams) {
    return this.fetchWithServerRequest<void>({
      url: this.getEndpointUrl(params, `/scale/${params.scaleId}`),
      request,
      method: "DELETE",
    });
  }

  static async editScale(
    request: Request,
    params: ServiceFeeScaleParams,
    data: ServiceFeeScaleData
  ) {
    return this.fetchWithServerRequest<ServiceFeeScale>({
      url: this.getEndpointUrl(params, `/scale/${params.scaleId}`),
      request,
      method: "PUT",
      body: data,
    });
  }

  static async createScale(
    request: Request,
    params: BaseServiceFeeParams,
    data: ServiceFeeScaleData
  ) {
    return this.fetchWithServerRequest<ServiceFeeScale>({
      url: this.getEndpointUrl(params, "/scale"),
      request,
      method: "POST",
      body: data,
    });
  }

  static async listScales(request: Request, params: ServiceFeeGroupParams) {
    return this.fetchWithServerRequest<ServiceFeeScale[]>({
      url: this.getEndpointUrl(params, `/${params.groupId}/scale`),
      request,
      method: "GET",
    });
  }
}
